export const SPEED_OPTIONS =[0.5, 1, 1.5, 2];
